import React, { Suspense }  from 'react';
import TitleHeader from 'components/presenters/header/TitleHeader'; 
import LoadingModal from 'components/presenters/modal/LoadingModal';
import styled from 'styled-components';

export default function PrivatePolicyPage() {

    const PrivatePolicy = React.lazy(() => import('components/containers/mypage/PrivatePolicy'));
    return (
    	<PageLayout>
    	<TitleHeader title={"개인정보 수집방침"} borderbottom={"solid calc(100vw*(1/375)) #d5d5d5"}/>  
            <Suspense fallback={<LoadingModal zIndex={500}/>}>
                <PrivatePolicy />
            </Suspense>
        </PageLayout>
    )
}


const PageLayout = styled.div`
	padding-top : 72px;
`;
